// Ratios
export const availableWidgetRatios = ['rectangle', 'square'] as const
export type WidgetRatio = (typeof availableWidgetRatios)[number]

// Formats
export const availableWidgetFormat = ['responsive', 'custom'] as const
export type WidgetFormat = (typeof availableWidgetFormat)[number]

// Displayed infos
export interface WidgetDisplayInfo {
  picture: boolean
  customText: string
}

export const MAX_WIDGET_WIDTH = 480
export const MIN_WIDGET_WIDTH = 240
export const RECTANGLE_WIDGET_HEIGHT = 130

export const xAspect = 1
export const yAspect = 200 / 240

// Color palette
export const availableWidgetColorPalettes = [
  'pink-yellow',
  'blue-purple-pink-orange',
  'blue-white',
  's-orange',
  's-green',
  's-blue',
  's-pink',
  's-black',
] as const
export type WidgetColorPalette = (typeof availableWidgetColorPalettes)[number]

// Complete query parameters
export interface WidgetParameters extends WidgetDisplayInfo {
  ratio: WidgetRatio
  format: WidgetFormat
  color: WidgetColorPalette
  size: number
}
